import { Order } from "@/api/SolarCloudApi";
import MintPaymentForm from "./MintPaymentForm";
import PayPalPaymentForm from "./PayPalPaymentForm";
import ApplePayPaymentForm from "./ApplePayPaymentForm";
import GooglePayPaymentForm from "./GooglePayPaymentForm";
import { PaymentType } from "@/queries/payments/useCreatePayment";
import StripePaymentForm from "./StripePaymentForm";

interface PaymentFormFactoryProps {
  selectedMethod: PaymentType;
  order: Order;
  onSuccess: (order: Order) => void;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
  beforePayment?: () => Promise<boolean>;
}

export default function PaymentFormFactory({
  selectedMethod,
  order,
  onSuccess,
  isSubmitting,
  setIsSubmitting,
  beforePayment,
}: PaymentFormFactoryProps) {
  switch (selectedMethod) {
    case PaymentType.Mint:
      return (
        <MintPaymentForm
          order={order}
          onSuccess={onSuccess}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Stripe:
      return (
        <StripePaymentForm
          orderId={order.uuid ?? ""}
          onSuccess={() => onSuccess(order)}
          onCancel={() => setIsSubmitting(false)}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.PayTo:
      return (
        <StripePaymentForm
          orderId={order.uuid ?? ""}
          onSuccess={() => onSuccess(order)}
          onCancel={() => setIsSubmitting(false)}
          paymentMethod={"payto"}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Klarna:
      return (
        <StripePaymentForm
          orderId={order.uuid ?? ""}
          onSuccess={() => onSuccess(order)}
          onCancel={() => setIsSubmitting(false)}
          paymentMethod={"klarna"}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Afterpay:
      return (
        <StripePaymentForm
          orderId={order.uuid ?? ""}
          onSuccess={() => onSuccess(order)}
          onCancel={() => setIsSubmitting(false)}
          paymentMethod={"afterpay_clearpay"}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.PayPal:
    case PaymentType.PayPalPayIn4:
      return (
        <PayPalPaymentForm
          order={order}
          onSuccess={onSuccess}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          payIn4={selectedMethod === PaymentType.PayPalPayIn4}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Apple:
      return (
        <ApplePayPaymentForm
          order={order}
          onSuccess={onSuccess}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Google:
      return (
        <GooglePayPaymentForm
          order={order}
          onSuccess={onSuccess}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          beforePayment={beforePayment}
        />
      );
    default:
      return (
        <div className="text-center py-8">
          <p className="text-gray-500">Please select a payment method</p>
        </div>
      );
  }
}
